import styled, { css } from 'styled-components';
import { media, Text, Flexbox, color, StyledLink } from '@morressier/ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LinkButton } from 'components/ProfileUIComponents';

export const ProfileBadge = styled.div<{ isPublic?: boolean }>`
  height: 54px;
  background: ${({ isPublic }) =>
    isPublic ? 'var(--color-green-95)' : 'var(--color-yellow-90)'};
`;

export const ProfileBadgeLink = styled(StyledLink)`
  font-size: var(--fontSizes-normal);
  line-height: var(--lineHeights-normal);
  font-weight: var(--fontWeights-regular);
`;

export const ProfileContainer = styled.div`
  background: var(--color-mono-100);
  padding: 32px;
`;

export const ProfileBadgeContainer = styled(Flexbox)`
  height: 100%;
`;

export const UserProfilePage = styled.div`
  margin-top: 7rem;
  ${media.xsmall`
    margin-top: 8rem;
  `}
  ${media.small`
    margin-top: 6rem;
  `}
  ${media.medium`
   margin-top: 4rem;
  `}
`;

export const Textmt8 = styled(Text)`
  margin-top: 8px;
`;

export const PrimaryAffiliation = styled(Flexbox)`
  margin-top: 8px;
`;

export const SecondaryText = styled(Text)`
  color: var(--color-mono-60);
`;

export const LocationIcon = styled(FontAwesomeIcon)`
  font-size: var(--fontSizes-normal);
  line-height: var(--lineHeights-l);
  margin-right: 4px;
  color: var(--color-mono-60);
`;

export const EditButton = styled(LinkButton)`
  margin-top: 1rem;
`;

export const LinksContainer = styled(Flexbox)`
  margin-top: 8px;
`;

export const BiographyContent = styled(Text)`
  white-space: pre-wrap;
`;

export const SideBar = styled(Flexbox)`
  margin-left: 2rem;
  gap: 1rem;
  border-left: 1px solid var(--color-mono-90);
  position: sticky;
  top: 5rem;
  width: max-content;
`;
export const DetailsSectionContainer = styled(Flexbox)`
  margin-top: 2rem;
  margin-bottom: 2rem;
`;
export const DetailsContainer = styled(Flexbox)`
  margin-left: 9rem;
  margin-right: 12rem;
  width: 100%;
`;

export const ModalImage = styled.img`
  margin-bottom: 2rem;
  max-height: 480px;
  min-height: 100px;
`;

export const Tooltip = styled.span`
  position: relative;

  &:hover::before,
  &:hover::after {
    visibility: visible;
    opacity: 1;
  }
  &::before {
    content: attr(data-tool-tip);
    visibility: hidden;
    opacity: 0;
    transition: opacity ease-out 150ms, bottom ease-out 150ms;
    position: absolute;
    width: 12.5rem;
    z-index: 1;

    padding: 4px 8px;
    background-color: var(--color-mono-100);
    color: color: ${color('secondaryBrand')};
    border-radius: 4px;
    font-size: var(--fontSizes-s);
    line-height: var(--lineHeights-s);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.16);
    left: 25px;
    top: -100%;

  }
  &::after {
    content: ' ';
    visibility: hidden;
    position: absolute;
    z-index: 1;
    margin-left: 0px;
    width: 12px;
    height: 12px;
    background: white;
    transform: translateX(-50%) translateY(-50%) rotate(45deg);

    // To adjust tooltip arrow position
    left: 25px;
    top:7px;
    box-shadow: -2px 4px 4px rgb(0 0 0 / 16%);
  }
`;

export const NavigationLink = styled.div<{ isSelected: boolean }>`
  text-decoration: none;
  padding-left: 1.5rem;
  color: var(--color-mono-50);
  font-size: var(--fontSizes-normal);
  line-height: var(--lineHeights-normal);
  cursor: pointer;
  ${({ isSelected }) =>
    isSelected
      ? css`
          border-left: 4px solid var(--color-blue-40);
          color: var(--color-mono-0);
          padding-left: 1.25rem;
          cursor: default;
        `
      : css`
          &:hover {
            padding-left: 1.25rem;
            border-left: 4px solid var(--color-mono-90);
          }
        `}
`;
